module.exports = __webpack_public_path__ + "static/media/skrzynkasurowa.74062be9.jpg";